import styled from 'styled-components';

export const TooltipIconWrapper = styled.div`
  cursor: pointer;
`;
